import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Chip,
  Avatar,
  DialogActions,
  Button,
} from "@mui/material";
import { format } from "date-fns";

const TaskDetailsModal = ({ open, task, onClose }) => {
  if (!task) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{task.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Due: {format(new Date(task.dueDate), "PPP")}
        </Typography>

        {task.location && (
          <Typography variant="body2" mt={1}>
            📍 {task.location}
          </Typography>
        )}

        {task.description && (
          <Typography variant="body1" mt={2}>
            {task.description}
          </Typography>
        )}

        <Box mt={2} display="flex" alignItems="center" gap={2}>
          {task.assignedTo && (
            <>
              <Avatar src={task.assignedTo.avatar} />
              <Typography>{task.assignedTo.name}</Typography>
            </>
          )}
          <Chip label={task.status} color="primary" />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskDetailsModal;
